export const API_CONFIG = {
  baseUrl: 'https://api-dash.lee.novakio.com'
  // baseUrl: 'http://localhost:8000'
};
